import { IAppState } from '../../../AppModulesWrapper';

import { IServicePeriod } from '../../types/reducers/publishTerms';

export const selectAuctionPeriod = (state: IAppState): IServicePeriod | null => {
  return state.servicePickerWidget.auction.period;
};
